export default __webpack_public_path__ + "static/media/high.3394d3a0.png";